<template>
  <div class="firstLoading">
    <div>
      <p style=";text-align:center">
        <strong><span style="font-size: 24px"><span style="">自由职业者服务协议</span></span></strong>
      </p>
      <p style="text-indent: 28px;background: rgb(255, 255, 255)">
        <span style="font-size: 14px">&nbsp;</span>
      </p>
      <p style="text-indent: 24px;background: rgb(255, 255, 255)">
        <span style="font-size: 12px"><span style="">甲方：{{bMerchant.merchantName}}</span></span>
      </p>
      <p style="text-indent: 24px;background: rgb(255, 255, 255)">
        <span style="font-size: 12px"><span style="">乙方：</span></span>
      </p>
      <p style="margin-top: 10px;text-indent: 24px;background: rgb(255, 255, 255)">
        <strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">根据《中华人民共和国合同法》及相关法律、法规、规范性文件，经甲乙双方友好协商，特达成协议如下：</span></span></span></strong>
      </p>
      <p style="margin-top: 10px;text-indent: 24px;background: rgb(255, 255, 255)">
        <strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">【提示条款】</span></span></span></strong>
      </p>
      <p style="text-indent: 24px;background: rgb(255, 255, 255)">
        <strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">为维护乙方的自身权益，在乙方点击同意或</span></span></span></strong><strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">书面签署</span></span></span></strong><strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">本协议之前，请认真阅读本协议，务必审慎阅读、充分理解各条款内容，特别是权利义务条款、法律适用和管辖条款。上述条款以粗体及下划线标识，乙方应重点阅读</span></span></span></strong><span style="font-size: 12px"><span style="">。</span></span>
      </p>
      <p style="text-indent: 24px;background: rgb(255, 255, 255)">
        <strong><span style="font-size: 12px"><span style="">【签约】</span></span></strong><strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">当乙方按照提示填写个人信息、阅读并同意本协议且完成全部申请或书面签署后，即表示乙方已充分阅读、理解并接受本协议的全部内容，并与甲方达成一致意见并成为甲方的自由职业者，此后乙方不得以未阅读</span>/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果乙方不同意本协议或其中任何条款约定，请乙方立即停止任何的申请/注册/或书面签署程序。</span></span></strong>
      </p>
      <p style="text-indent: 24px;background: rgb(255, 255, 255)">
        <strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">【服务委托】双方同意，</span><a name="_Hlk56465630"></a><span style="">甲方有权授权和委托甲方关联公司享有和履行本协议项下甲方的权利和义务</span><span style="">，甲方前述授权和委托无需另行取得乙方同意。</span><a name="_Hlk56463376"></a></span></span></strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">前述关联公司，指在甲方及该公司二者中，一方直接或者间接持有另一方的股份总和达到</span>25%以上；<a name="_Hlk56493834"></a><span style="">一方和另一方</span><span style="">直接或者间接同为第三方所持有的股份合计达到</span>25%以上；如果一方通过第三方对另一方间接持有股份，只要其对该第三方持股比例达到25%以上，则其对另一方的持股比例按照该第三方对另一方的持股比例计算；<a name="_Hlk56493884"></a><span style="">虽然直接或间接持股未达到</span>25%以上，但通过有权委派公司的董事会或类似管理机构的大部分成员，或通过合约安排或其他方式，能够主导公司的管理或政策；<a name="_Hlk56493786"></a><span style="">两个及以上具有夫妻、直系血亲、兄弟姐妹以及其他抚养、赡养关系的自然人共同持股同一企业，在判定关联关系时持股比例合并计算</span><span style="">。</span></span></span>
      </p>
      <p style="text-indent: 24px;background: rgb(255, 255, 255)">
        <strong><span style="font-size: 12px"><span style="">【合作关系】</span></span></strong><strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">甲方与乙方通过本协议建立业务分包合作关系，适用《中华人民共和国合同法》、《中华人民共和国民法总则》等民事法律、法规。</span></span></span></strong><strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">双方不构成任何劳动</span>/劳务合同关系或其他类似劳动法律关系</span></span></strong><strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">不适用《中华人民共和国劳动法》、《中华人民共和国劳动合同法》等劳动关系的法律、法规。</span></span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">&nbsp;</span>
      </p>
      <p style="text-indent: 24px">
        <strong><span style="font-size: 12px"><span style="">协议条款：</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">&nbsp;</span>
      </p>
      <p style="text-indent: 24px">
        <strong><span style="font-size: 12px"><span style="">第一条</span> <span style="">服务工作内容</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">1.1 甲方依据服务需求，特选用乙方提供/完成相关服务，该等服务的内容主要依据为甲方的服务规范，服务规范包括但不限于甲方的业务要求、制度要求、特殊节日着装要求等。</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">1.2 乙方应按照甲方的服务规范规定的标准来完成分包服务。</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">1.3 乙方承诺和保证，乙方有提供本协议约定服务所对应的相应资质和专业能力，乙方依据本协议约定收取相关服务费用不违反任何法律法规和政策规定。若依据相关规定，乙方提供的相关服务和收费，应通过所在机构或以其他法律规定的方式进行的，则由乙方负责办理全部事宜，并提前通知甲方。若因乙方的自身原因未办理前述事宜，则乙方应承担由此引起的全部法律后果，若乙方未提前通知甲方，给甲方造成损失的，乙方应赔偿由此给乙方造成的全部经济损失。</span>
      </p>
      <p style="margin-top: 10px;text-indent: 24px">
        <strong><span style="font-size: 12px"><span style="">协议效力</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">2.1</span><strong><span style="font-size: 12px"><span style="">乙方的签约信息（包括姓名、身份证号码、银行信息等信息），以乙方在甲方平台注册会员时提供的信息为准。</span></span></strong><strong><span style="text-decoration:underline;"><span style="font-size: 12px"><span style="">乙方承诺并保证所提供的签约信息真实、准确，以免影响本协议效力。</span></span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <strong><span style="text-decoration:underline;"><span style="font-size: 12px">2.2本协议条款若在甲方网站上发布，自乙方线上点击同意/确认之日起生效；若为书面签署，自双方签署本协议之日起生效；若采用电子合同签署，甲乙双方通过网络页面完成相应操作，生成双方的电子签章后即表示甲乙双方已达成本协议，本协议的生效时间以电子合同系统中显示为准。</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">2.3 本协议的签署取代乙方与甲方关联公司之前签署的任何合同。乙方与甲方关联公司在本协议签署之前的任何合同，自本协议生效之日起自动终止、解除。</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">2.4 本协议有效期限一年。期限届满，双方应另行签署新的协议；若双方未签署新的协议，而以实际行动继续合作的，视为双方同意本协议期限顺延直至按照本协议约定终止或解除时为止。</span>
      </p>
      <p style="margin-top: 10px;text-indent: 24px">
        <strong><span style="font-size: 12px"><span style="">第三条</span> <span style="">甲方的权利和义务</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">3.1 </span><strong><span style="text-decoration:underline;"><span style=";font-size: 12px"><span style="">乙方应根据甲方的安排和要求完成相关的服务，服务期间乙方应遵守相关的法律法规政策规定，遵守甲方的服务规范</span></span></span></strong><span style=";font-size:12px"><span style="">。</span></span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">3.2 甲方将对乙方在本协议期限内提供的分包服务成果进行验收。</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">3.3 </span><strong><span style=";font-size: 12px"><span style="">甲方应按约定及时向乙方支付费用。此处乙方应明确：乙方作为甲方的自由职业者人员，在需求方依约向甲方支付合作款项前提下，乙方的相关费用结算将由甲方及甲方关联公司完成支付。</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">3.4 </span><strong><span style="text-decoration:underline;"><span style=";font-size: 12px"><span style="">乙方同意，乙方不可撤销地授权甲方为提供为支付服务费用的需要获取乙方的相关信息（包括但不限于个人身份信息、实名登记手机号码、银行账户相关信息等），并将乙方的相关信息提交甲方关联公司或其他第三方机构进行身份验证。若乙方提供任何错误、虚假、失效或不完整的资料，或者甲方有合理的理由怀疑资料错误、虚假、过期或不完整，甲方有权暂停或终止向乙方结算服务费用；若因国家法律法规、部门规章或监管机构的要求，甲方需要乙方补充提供相关资料时，如乙方不能及时配合提供，甲方有权暂停或终止向乙方结算服务费用。对此，甲方不承担任何违约责任，乙方承诺并同意承担因此所产生的所有损失。</span></span></span></strong>
      </p>
      <p style="margin-top: 10px;text-indent: 24px">
        <strong><span style=";font-size: 12px"><span style="">第四条</span> <span style="">乙方的权利和义务</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">4.1 </span><span style=";font-size:12px"><span style="">乙方应按时尽责地完成甲方要求的服务内容，并达到规定的质量标准，不得有侵犯他人知识产权、财产权、人身权、肖像权、隐私权、商业秘密或其他合法权益以及其他违反国家法律法规、国家政策、或有悖于公序良俗的内容。</span></span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">4.2</span><strong><span style="text-decoration:underline;"><span style=";font-size: 12px">&nbsp;<span style="">协议期内，乙方应在甲方许可范围内使用本协议有关的商业信息；协议期内以及协议终止后，乙方有义务对双方合作的有关协议及合作过程中知悉的甲方的相关信息予以保密，未经甲方书面许可，乙方不得以任何方式向其它方泄漏、给予或转让该等保密信息。否则，因此导致甲方的损失，由乙方负责赔偿。</span></span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">4.3 除本协议事项外，乙方不得以甲方名义开展任何与完成约定的服务无关的业务或活动。</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">4.4 </span><strong><span style="text-decoration:underline;"><span style=";font-size: 12px"><span style="">协议期内以及协议终止后，乙方发生的任何意外包括但不限于人身意外伤害、人事伤亡、财产损失等，甲方不承担任何责任，均由乙方自行负责。</span></span></span></strong>
      </p>
      <p style="margin-top: 10px;text-indent: 24px">
        <strong><span style=";font-size: 12px"><span style="">第五条</span> <span style="">服务费用及支付方式</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">5.1 </span><strong><span style="text-decoration:underline;"><span style=";font-size: 12px"><span style="">甲方将根据乙方完成服务标准</span>/质量效果/数量等确定服务费用，并按时向乙方支付服务费，具体服务费用由甲方根据甲方相关的业务结算规则确定。该等业务结算规则根据经营需要会有浮动调整，乙方清楚并了解该等浮动调整为正常情况。甲方以人民币形式向乙方支付服务费用。乙方应缴纳的（生产经营所得）个人所得税及其他相关税费由甲方委托有资质的单位代征代缴。</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">5.2 </span><strong><span style="text-decoration:underline;"><span style=";font-size: 12px"><span style="">甲方服务费发放的目标账户以乙方在甲方平台实名认证的乙方名下的银行账户为准</span></span></span></strong><span style=";font-size:12px"><span style="">，因乙方提供的银行账户不实</span>/有误/信息不符等造成的一切损失由乙方自行承担。如乙方账户变更或发生不可用等情况时，应及时进行变更操作并告知甲方，否则，由此造成的一切损失由乙方自行负责。</span>
      </p>
      <p style="margin-top: 10px;text-indent: 24px">
        <strong><span style=";font-size: 12px"><span style="">第六条</span> <span style="">违约责任</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">6.1 双方应按本协议约定履行，如有违反，守约方有权要求对方及时改正；造成对方损失的，守约方有权要求违约方赔偿。</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">6.2 因不可抗力造成损失的，彼此不负赔偿责任，但发生不可抗力一方应及时将有关情况通知另一方，并尽最大努力进行补救。本协议所称不可抗力是指不能预见、不能克服并不能避免且对一方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、火灾、风暴和疫情等以及社会事件如战争、动乱、政府行为、黑客事件、大范围电信事故等。</span>
      </p>
      <p style="margin-top: 10px;text-indent: 24px">
        <strong><span style=";font-size: 12px"><span style="">第七条</span> <span style="">协议的终止</span></span></strong>
      </p>
      <p style="text-indent:24px">
        <span style=";font-size:12px">7.1 发生以下情形时，本协议终止：</span>
      </p>
      <p style="text-indent:24px">
        <span style=";font-size:12px">a. 协议期限届满或任何一方提前30日书面通知对方要求终止协议的。但乙方单方要求终止协议的，应不影响甲方业务正常运营；</span>
      </p>
      <p style="text-indent:24px">
        <span style=";font-size:12px">b. 一方违反本协议约定，且违约方在非违约方书面通知后15日内仍未予改正的，非违约方可以书面通知的形式终止本协议；</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">c. 乙方未能达到甲方的相关要求，甲方可以给予乙方警告；此后如仍发生类似情况的，甲方有权单方通知乙方终止本协议；</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">d. 甲方终止或变更业务模式而不需要乙方继续履行本协议;</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">e. 甲方认为乙方不适合继续提供服务的；</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">f. 乙方有违法犯罪行为、被依法追究刑事责任、被列为失信人或被执行人；</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">g. 其他原因导致本协议不再继续履行的。</span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">7.2</span><span style=";font-size:12px">&nbsp;</span><span style=";font-size:12px"><span style="">本协议终止后，乙方需配合甲方办理相关手续（如有）。若因乙方不配合办理该等手续，而造成甲方无法向乙方结算相应服务费用的，该后果由乙方自行承担。</span></span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">7.3 本协议的提前终止不影响已经产生的权利义务关系。</span>
      </p>
      <p style="margin-top: 10px;text-indent: 24px">
        <strong><span style=";font-size: 12px"><span style="">其他</span></span></strong>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">8.1</span><strong><span style="text-decoration:underline;"><span style=";font-size: 12px">&nbsp;<span style="">因履行本协议发生的纠纷，双方应友好协商解决，协商不成的，向甲方住所地人民法院诉讼解决</span></span></span></strong><span style=";font-size:12px"><span style="">。</span></span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">8.</span><span style=";font-size:12px">2</span><span style=";font-size:12px">&nbsp;<span style="">甲方有权根据业务需要修改本协议条款。</span></span>
      </p>
      <p style="text-indent: 24px">
        <span style=";font-size:12px">8.</span><span style=";font-size:12px">3</span><span style=";font-size:12px">&nbsp;</span><span style=";font-size:12px"><span style="">在履行本协议过程中甲方向乙方发出的一切通知（包括电子邮件、</span></span><span style="text-decoration:underline;"><span style=";font-size: 12px"><span style="">站内通知</span></span></span><span style=";font-size:12px"><span style="">、手机短信、挂号信、</span>EMS<span style="">或快递等），均以本协议文尾乙方所列的联系信息及乙方在甲方平台注册时提供的信息为准。该等联系信息发生变更时，乙方应立即以书面形式通知甲方变更后的信息，否则仍以原信息为准。以电子邮件、站内通知、手机短信发出的，在发出日的次日视为送达；以挂号信、</span><span style="font-family:Calibri">EMS</span><span style="">或快递发出的，在邮戳日</span><span style="font-family:Calibri">/</span><span style="">妥投日的</span><span style="font-family:Calibri">5</span><span style="">日后视为送达。</span></span>
      </p>
      <div style="text-align:center;margin-bottom:20px;">（以下无正文）</div>

      <div class="footer">
        <div class="jia">
          <p>甲方（盖章）：</p>
          <p class="date">日期：</p>
        </div>
        <div>
          <p>乙方（签字）：</p>
          <p>身份证号：</p>
          <p>手机号码：</p>
          <p>日期：</p>
        </div>
      </div>
    </div>
    <div class="bottom">本协议由汉唐融科公司提供</div>
  </div>
</template>
<script>
import BusinessDict from "../../utils/businessDict";

export default {
  data(){
    return{
      bMerchant: {
        merchantName: "",
        contactName: "",
        contactMobile: "",
        contactEmail: "",
        contactAddress: "",
        serviceRate: "*",
      },
      loading:true
    }
  },
  mounted() {
    const url = new URL(location.href);
    let b = url.searchParams.get('b');
    console.log(url, b);
    b = b || "zslhkjyxgs";
    let bMerchant = BusinessDict.BMerchant[b];
    console.log(bMerchant);
    if (bMerchant) {
      this.bMerchant = bMerchant;
    }
    console.log(this.bMerchant);
  },
  methods:{
  }
}
</script>
<style lang="less" scoped>
.firstLoading{
  padding: 15px;
  box-sizing: border-box;
  text-align: left;
}
.bottom {
  width: 100%;
  font-size: 12px;
  line-height: 50px;
  text-align: center;
  bottom: 0px;
  left: 0;
  font-weight:bold
  }
  .footer{
    display: flex;
    justify-content: space-around;
    padding-bottom:40px ;
  }
  .footer div{
    text-align: left;
  }
  .jia{
    position: relative;
  }
  .date{
    position: absolute;
    bottom: 0;
    left: 0;
  }
  p,div,span{
    font-family:微软雅黑;
  }
</style>



// WEBPACK FOOTER //
// src/pages/agreement/aggreement_yz.vue